import {AutogenLayoutMarketExprtOutputSettingsPanel} from "./autogen/AutogenLayoutMarketExprtOutputSettingsPanel";

export class MarketExprtOutputSettingsPanel extends AutogenLayoutMarketExprtOutputSettingsPanel{

}
